import { atom } from "recoil";

export const atomIsOpenModal = atom({
  key: 'atomIsOpenModal',
  default: false
})